import { groupBy } from '@seiue/util'

/**
 * 搜索字符串格式化
 * @param str - 字符串
 */
export const searchParamFormat = (str?: string) => {
  if (!str) return undefined
  // 暂时隐藏，后续可能会用到，勿删
  // const dotReg = /,|，/
  // const numReg = /^\d+$/
  // if (dotReg.test(str)) {
  //   const list = str.split(dotReg)
  //   const group = groupBy(list, (i) =>
  //     numReg.test(i.trim()) ? 'phoneIn' : 'nameIn'
  //   )
  //   return {
  //     phoneIn: group['phoneIn'] ? group['phoneIn'].join(',') : undefined,
  //     nameIn: group['nameIn'] ? group['nameIn'].join(',') : undefined,
  //   }
  // }
  return {
    nameOrPhoneLikes: str.replace(/,|，/, ','),
  }
}
